<router>
    {
        name: 'notifyStats',
    }
</router>
    
<template lang="pug">
    v-container(fluid)
        v-row
            v-col
                devopsnotifystats
        
</template>
    
<script>
import devopsnotifystats from '@/components/devops/notifyStats';
export default {
    meta: {
        role: 'devopsnotifystats'
    },
    components: {
        devopsnotifystats
    },
    data () {
        return {
        };
    },
    methods: {
    
    },
    computed: {
    
    },
    mounted () {
    }
};
</script>
    
<style scoped></style>